import * as React from 'react';
import * as PropTypes from 'prop-types';
import { store } from '../../../store/index';
import { IInitialState, DataContext, WebChatDTO, TicketStatus, WebChatStatus } from '../../../models/chat.models';
import { webChatService } from '../../../services/webchat.service';

const Prompt = ({ className, title, prompt }) => {
    const context: IInitialState = React.useContext(DataContext);
    const handleClick = async () => {
        let ticketMessageDto = await webChatService.sendMessage({ Message: prompt, Session: context.webChatDto.Session, Attachment: null });
        
        if (ticketMessageDto) {
            context.webChatDto.Status = WebChatStatus.Active;
            store.dispatch({ type: 'ADD_MESSAGE_TO_LIST', payload: ticketMessageDto });
            store.dispatch({ type: 'SET_MESSAGE', payload: '' });
            store.dispatch({ type: 'SET_MESSAGE_HEIGHT', payload: 56 });

            let chatBotResponseDto = await webChatService.getChatBotMessage({ Message: prompt, Session: context.webChatDto.Session, Attachment: null });
            if (chatBotResponseDto) {
            store.dispatch({ type: 'ADD_MESSAGE_TO_LIST', payload: chatBotResponseDto });
            store.dispatch({ type: 'SET_MESSAGE', payload: '' });
            store.dispatch({ type: 'SET_MESSAGE_HEIGHT', payload: 56 });
            }
        }
  };

  return (
    <button className={className} onClick={handleClick}>
      {title}
    </button>
  );
};

Prompt.propTypes = {
  title: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired
};

export default Prompt;